import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/constants/routes';

/** Edit Profile is a header popup. Bookmarks of this path land on the dashboard. */
export const Route = createFileRoute('/admin/_app/profile')({
  beforeLoad: () => {
    throw redirect({ to: ROUTES.dashboard });
  },
  component: () => null,
});
